import { REGEX_CONDITION } from '../../../constants';
import { first } from 'utils';

/**
 * Retrieves the Adgroup ID based on the provided preference string.
 *
 * @param pref - A string representing the user's preference, which may be undefined.
 * @returns The first match of the regular expression defined in REGEX_CONDITION.A_PLUS_DIGITS,
 *          or an empty string if no matches are found.
 */
export function getAdgroupId(pref: string | undefined) {
  const userPref = pref || '';
  const matches = userPref.match(REGEX_CONDITION.A_PLUS_DIGITS);

  return first(matches || [], '');
}
